import React, { useState, useEffect } from "react";
import {
  ToolBarContainer,
  ToolConfigurationHeader,
  ToolConfigurationBody,
  ToolConfigurationFooter,
  PopoverHdr,
  ToolConfigurationSaveButton,
  ToolConfigurationCancelButton,
  SuggestionCardContainer,
  SuggestionCard,
} from "./style";
import DeleteIcon from "../../assets/workflows/delete-icon.svg";
import Tooltip from "@mui/material/Tooltip";

import {
  TextField,
  TextareaAutosize,
  FormControl,
  Select,
  MenuItem,
  Box,
  InputLabel,
  Button,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import SparklesIcon from "../../assets/workflows/sparkles-icon.svg";
import InfoIcon from "../../assets/workflows/info-icon.svg";
import XIcon from "../../assets/workflows/x-icon.svg";
import axios from "axios";
import { CHAT_BASE_API_URL, API_BASE_URL } from "../../constant/constant";
import { useSnackbar } from "../../context/SnackBarContext";

const ToolConfiguration = ({
  treeData,
  node,
  selectedAction,
  handleDelete,
  description,
  setDescription,
  descriptionError,
  setDescriptionError,
  configValues,
  setConfigValues,
  configTypes,
  setConfigTypes,
  configErrors,
  setConfigErrors,
  selectedOptions,
  setSelectedOptions,
  onClose,
  onSave,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [apiHeaderKeyPairs, setApiHeaderKeyPairs] = useState([
    { key: "", value: "" },
  ]);
  const [isApiHeaderRequired, setIsApiHeaderRequired] = useState(false);
  const [loading, setLoading] = useState(true);
  const [skills, setSkills] = useState([]);
  const [meetingData, setMeetingData] = useState([]);
  const [isMeetingDataLoading, setIsMeetingDataLoading] = useState(false);
  const [selectedMeetingMode, setSelectedMeetingMode] = useState({});
  const token = localStorage.getItem("token");
  const showSnackbar = useSnackbar();

  const fetchUserMeetings = async () => {
    try {
      setIsMeetingDataLoading(true);
      const email = localStorage.getItem("email");
      const response = await axios.get(
        `https://api.transcriber.aivoria.nl/api/user/get-all-meetings?email=${email}`,
        {
          headers: {
            "Content-Type": "application/json",
            // "x-auth-token": token || "",
          },
        },
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      console.error("Error fetching meetings:", error);
      return [];
    } finally {
      setIsMeetingDataLoading(false);
    }
  };

  const handleMeetingModeChange = async (title, mode) => {
    setSelectedMeetingMode((prev) => ({ ...prev, [title]: mode }));

    if (mode === "latest") {
      let meetings = meetingData;
      if (meetings.length === 0) {
        meetings = await fetchUserMeetings();
        setMeetingData(meetings);
      }
      if (meetings.length > 0) {
        handleConfigChange(title, meetings[0].meeting_id);
      }
    } else if (mode === "select") {
      if (meetingData.length === 0) {
        const meetings = await fetchUserMeetings();
        setMeetingData(meetings);
      }
    }
  };

  useEffect(() => {
    if (selectedAction) {
      try {
        const configuration = JSON.parse(selectedAction.configuration);
        const initialConfigTypes = {};
        let apiHeaderConfig = null;

        configuration.forEach((config) => {
          if (!configTypes[config.title]) {
            initialConfigTypes[config.title] = "Static";
            if (config.title === "API Header") {
              apiHeaderConfig = config;
            }
          }
        });
        setConfigTypes((prev) => ({
          ...prev,
          ...initialConfigTypes,
        }));

        if (apiHeaderConfig) {
          setIsApiHeaderRequired(apiHeaderConfig.required);
        }

        // Initialize API Header key-pairs if applicable
        if (configuration.some((config) => config.title === "API Header")) {
          try {
            const parsedDescription = node?.formData?.description
              ? JSON.parse(node.formData.description)
              : [];
            const apiHeaderConfigData = parsedDescription.find(
              (item) => item.title === "API Header",
            );
            const apiHeaderContent = apiHeaderConfigData
              ? apiHeaderConfigData.content
              : "";
            const parsedApiHeader = apiHeaderContent
              ? JSON.parse(apiHeaderContent)
              : [{ key: "", value: "" }];
            setApiHeaderKeyPairs(
              Array.isArray(parsedApiHeader) && parsedApiHeader.length > 0
                ? parsedApiHeader
                : [{ key: "", value: "" }],
            );
            setConfigValues((prev) => ({
              ...prev,
              "API Header": JSON.stringify(
                Array.isArray(parsedApiHeader) && parsedApiHeader.length > 0
                  ? parsedApiHeader
                  : [{ key: "", value: "" }],
              ),
            }));
          } catch (error) {
            console.error("Error parsing API Header:", error);
            setApiHeaderKeyPairs([{ key: "", value: "" }]);
            setConfigValues((prev) => ({
              ...prev,
              "API Header": JSON.stringify([{ key: "", value: "" }]),
            }));
          }
        }
      } catch (error) {
        console.error("Error parsing configuration:", error);
      }
    }
  }, [selectedAction]);

  const handleConfigChange = (title, value) => {
    setConfigValues((prev) => ({
      ...prev,
      [title]: value,
    }));
    setConfigErrors((prev) => ({
      ...prev,
      [title]: false,
    }));
  };

  const handleOptionChange = (title, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [title]: value,
    }));
    setConfigErrors((prev) => ({
      ...prev,
      [title]: false,
    }));
  };

  const handleConfigTypeChange = (title, type, config) => {
    // Prevent changing type for API Header in Send Post Request and Send GET Request
    if (
      (selectedAction.toolName === "Send Post Request" ||
        selectedAction.toolName === "Send GET Request") &&
      title === "API Header"
    ) {
      return;
    }

    setConfigTypes((prev) => ({
      ...prev,
      [title]: type,
    }));

    if (type === "Use AI") {
      setConfigValues((prev) => ({
        ...prev,
        [title]: "",
      }));
      setConfigErrors((prev) => ({
        ...prev,
        [title]: false,
      }));
    }

    if (type === "Dynamic") {
      setConfigValues((prev) => ({
        ...prev,
        [title]: config.hint,
      }));
      setConfigErrors((prev) => ({
        ...prev,
        [title]: false,
      }));
    }
  };

  const removeNodeById = (currentNode, nodeId) => {
    if (currentNode.id === nodeId) {
      return null;
    }

    if (currentNode.children) {
      currentNode.children = currentNode.children
        .map((child) => removeNodeById(child, nodeId))
        .filter((child) => child !== null);
    }

    return currentNode;
  };

  const handleGetSuggestions = async () => {
    const deepCopyTreeData = JSON.parse(JSON.stringify(treeData));
    const updatedTreeData = deepCopyTreeData
      .map((item) => removeNodeById(item, node.id))
      .filter((item) => item !== null);

    const payload = {
      workflow_history: JSON.stringify(updatedTreeData),
    };
    try {
      const response = await fetch(
        `${CHAT_BASE_API_URL}/workflows_condition_suggestions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x_auth_token": localStorage.getItem("token") || "",
          },
          body: JSON.stringify(payload),
        },
      );
      if (response.status === 400) {
        showSnackbar(response.text, "error");
        return;
      }
      const data = await response.json();
      setSuggestions(data);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setDescription(suggestion);
    setSuggestions([]);
  };

  // Handlers for API Header key-pairs
  const addApiHeaderPair = () => {
    const newKeyPairs = [...apiHeaderKeyPairs, { key: "", value: "" }];
    setApiHeaderKeyPairs(newKeyPairs);
    setConfigValues((prev) => ({
      ...prev,
      "API Header": JSON.stringify(newKeyPairs),
    }));
    setConfigErrors((prev) => ({
      ...prev,
      "API Header": false,
    }));
  };

  const removeApiHeaderPair = (index) => {
    const newKeyPairs = apiHeaderKeyPairs.filter((_, i) => i !== index);
    const updatedKeyPairs =
      newKeyPairs.length > 0 ? newKeyPairs : [{ key: "", value: "" }];
    setApiHeaderKeyPairs(updatedKeyPairs);
    setConfigValues((prev) => ({
      ...prev,
      "API Header": JSON.stringify(updatedKeyPairs),
    }));
    // Update errors based on new state
    if (
      isApiHeaderRequired &&
      (updatedKeyPairs.length === 0 ||
        updatedKeyPairs.some((pair) => !pair.key || !pair.value))
    ) {
      setConfigErrors((prev) => ({
        ...prev,
        "API Header": true,
      }));
    } else {
      setConfigErrors((prev) => ({
        ...prev,
        "API Header": false,
      }));
    }
  };

  const handleApiHeaderChange = (index, field, value) => {
    const newKeyPairs = apiHeaderKeyPairs.map((pair, i) => {
      if (i === index) {
        return { ...pair, [field]: value };
      }
      return pair;
    });
    setApiHeaderKeyPairs(newKeyPairs);
    setConfigValues((prev) => ({
      ...prev,
      "API Header": JSON.stringify(newKeyPairs),
    }));
    // Update errors based on new state
    if (
      isApiHeaderRequired &&
      (newKeyPairs.length === 0 ||
        newKeyPairs.some((pair) => !pair.key.trim() || !pair.value.trim()))
    ) {
      setConfigErrors((prev) => ({
        ...prev,
        "API Header": true,
      }));
    } else {
      setConfigErrors((prev) => ({
        ...prev,
        "API Header": false,
      }));
    }
  };

  // Function to validate all fields before saving
  const validateBeforeSave = () => {
    let isValid = true;

    // Validate description
    if (!description.trim()) {
      setDescriptionError(true);
      isValid = false;
    } else {
      setDescriptionError(false);
    }

    // Validate config values
    Object.keys(configValues).forEach((key) => {
      // Skip validation for Dynamic fields
      if (configTypes[key] === "Dynamic") {
        setConfigErrors((prev) => ({
          ...prev,
          [key]: false,
        }));
        return;
      }

      if (key === "API Header") {
        if (isApiHeaderRequired) {
          const apiHeaders = JSON.parse(configValues[key]);
          if (
            apiHeaders.length === 0 ||
            apiHeaders.some((pair) => !pair.key.trim() || !pair.value.trim())
          ) {
            setConfigErrors((prev) => ({
              ...prev,
              [key]: true,
            }));
            isValid = false;
          } else {
            setConfigErrors((prev) => ({
              ...prev,
              [key]: false,
            }));
          }
        } else {
          // If API Header is not required, no need to set errors
          setConfigErrors((prev) => ({
            ...prev,
            [key]: false,
          }));
        }
      } else if (!configValues[key].trim()) {
        setConfigErrors((prev) => ({
          ...prev,
          [key]: true,
        }));
        isValid = false;
      } else {
        setConfigErrors((prev) => ({
          ...prev,
          [key]: false,
        }));
      }
    });

    // Validate selected options
    Object.keys(selectedOptions).forEach((key) => {
      if (!selectedOptions[key]) {
        setConfigErrors((prev) => ({
          ...prev,
          [key]: true,
        }));
        isValid = false;
      } else {
        setConfigErrors((prev) => ({
          ...prev,
          [key]: false,
        }));
      }
    });

    return isValid;
  };

  // Modified save handler to include validation
  const handleSave = () => {
    if (validateBeforeSave()) {
      onSave();
    }
  };
  const fetchSkills = async () => {
    try {
      setLoading(true);
      const userId = localStorage.getItem("id");
      const res = await axios.get(
        `${API_BASE_URL}/api/skill/user/` + userId,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": token || "",
          },
        },
      );

      if (res.data.responseCode === 429) {
        showSnackbar(res.data.message, "error");
        return;
      }
      setSkills(res.data.skills);
    } catch (error) {
      console.error("Error fetching skills:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSkills();
    // Check for both English and Dutch tool names
    const isMeetingTranscription = 
      selectedAction?.toolName === "Get Meeting Transcription" ||
      selectedAction?.toolName === "Ontvang een vergadertranscriptie";
      
    if (isMeetingTranscription) {
      const loadMeetings = async () => {
        const meetings = await fetchUserMeetings();
        setMeetingData(meetings);
      };
      loadMeetings();
      
      // Initialize selectedMeetingMode with "select" as default
      try {
        const configuration = JSON.parse(selectedAction.configuration);
        const initialMeetingMode = {};
        configuration.forEach((config) => {
          initialMeetingMode[config.title] = "select";
        });
        setSelectedMeetingMode(initialMeetingMode);
      } catch (error) {
        console.error("Error initializing meeting mode:", error);
      }
    }
  }, [selectedAction]);

  return (
    <ToolBarContainer>
      <ToolConfigurationHeader>
        {node?.img === "ConditionIcon" ? (
          "Condition Info"
        ) : node?.img === "TriggerIcon" ? (
          "Trigger Info"
        ) : node?.img === "EndIcon" ? (
          "End Info"
        ) : (
          <div className="flex flex-col gap-2">
            <div>{selectedAction?.toolName}</div>
            <div style={{ fontSize: "12px", fontWeight: "400" }}>
              {selectedAction?.toolDescription}
            </div>
          </div>
        )}
        {node?.img !== "TriggerIcon" && (
          <Tooltip title="Delete" placement="top">
            <img src={DeleteIcon} alt="Delete" onClick={handleDelete} />
          </Tooltip>
        )}
      </ToolConfigurationHeader>
      <ToolConfigurationBody>
        {(node?.img === "ConditionIcon" || node?.img === "TriggerIcon") && (
          <>
            <PopoverHdr
              style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "0.4rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  justifyContent: "space-between",
                }}
              >
                {node?.img === "ConditionIcon"
                  ? "Enter a condition with yes or no answers."
                  : "Enter a scenario where you want to trigger this workflow."}
                {node?.img === "ConditionIcon" && (
                  <Tooltip title="Get Suggestions from AI" placement="top">
                    <img
                      style={{ cursor: "pointer" }}
                      src={SparklesIcon}
                      alt="Sparkles"
                      onClick={handleGetSuggestions}
                    />
                  </Tooltip>
                )}
              </div>
            </PopoverHdr>
            {suggestions.length > 0 && (
              <div style={{ marginBottom: "0.5rem" }}>
                <SuggestionCardContainer>
                  {suggestions.map((suggestion) => (
                    <SuggestionCard
                      key={suggestion}
                      onClick={() => handleSuggestionClick(suggestion)}
                    >
                      {suggestion}
                    </SuggestionCard>
                  ))}
                </SuggestionCardContainer>
              </div>
            )}

            <TextField
              placeholder={
                node?.img === "ConditionIcon"
                  ? "Are there any items in my todo list?"
                  : "When I inquire about fetching news articles during a conversation"
              }
              fullWidth
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setDescriptionError(false);
              }}
              error={descriptionError}
              helperText={descriptionError ? "Description is required" : ""}
            />
          </>
        )}
        {selectedAction &&
          node?.img !== "ConditionIcon" &&
          node?.img !== "TriggerIcon" &&
          node?.img !== "EndIcon" && (
            <>
              {JSON.parse(selectedAction.configuration).map((config, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: `${config.title === "Name of Skill" ? "column" : "row"}`,
                      width: "100%",
                      gap: "10px",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <PopoverHdr
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        width: "100%",
                      }}
                    >
                      {config.title}
                      {
                        config.title === "Name of Skill" && (
                          // <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth style={{ marginTop: "10px" }}>
                            <InputLabel id={`select-label-${config.title}`}>
                              {config.title}
                            </InputLabel>
                            <Select
                              labelId={`select-label-${config.title}`}
                              id={`select-${config.title}`}
                              value={configValues[config.title] || ""}
                              label={config.title}
                              onChange={(e) =>
                                handleConfigChange(config.title, e.target.value)
                              }
                            >
                              {loading ? (
                                <MenuItem disabled={loading}>
                                  Loadind...
                                </MenuItem>
                              ) : skills.length === 0 ? (
                                <MenuItem disabled={true}>
                                  No skills Found
                                </MenuItem>
                              ) : (
                                skills.map((option) => (
                                  <MenuItem
                                    key={option?._id}
                                    value={option?.name}
                                  >
                                    {option?.name}
                                  </MenuItem>
                                ))
                              )}
                            </Select>
                          </FormControl>
                        )
                        // {/* </Box> */}
                      }
                    </PopoverHdr>
                    {!(
                      (selectedAction.toolName === "Send Post Request" ||
                        selectedAction.toolName === "Send GET Request") &&
                      config.title === "API Header"
                    ) &&
                      selectedAction.toolName !== "Get Meeting Transcription" &&
                      selectedAction.toolName !== "Ontvang een vergadertranscriptie" &&
                      config.type !== "Dropdown" &&
                      config.title !== "Name of Skill" && (
                        <FormControl
                          size="small"
                          sx={{ minWidth: 120 }}
                          style={{ width: "100%" }}
                        >
                          <Select
                            value={configTypes[config.title] || "Static"}
                            onChange={(e) =>
                              handleConfigTypeChange(
                                config.title,
                                e.target.value,
                                config,
                              )
                            }
                            disabled={
                              (selectedAction.toolName ===
                                "Send Post Request" ||
                                selectedAction.toolName ===
                                "Send GET Request") &&
                              config.title === "API Header"
                            }
                          >
                            <MenuItem value="Use AI">Use AI</MenuItem>
                            <MenuItem value="Dynamic">Dynamic</MenuItem>
                            <MenuItem value="Static">Static</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    {(selectedAction.toolName === "Get Meeting Transcription" ||
                      selectedAction.toolName === "Ontvang een vergadertranscriptie") && (
                        <div style={{ width: "100%", marginTop: "10px" }}>
                          <RadioGroup
                            value={selectedMeetingMode[config.title] || "select"}
                            onChange={(e) =>
                              handleMeetingModeChange(config.title, e.target.value)
                            }
                          >
                            <FormControlLabel
                              value="select"
                              control={<Radio />}
                              label="Select Meeting"
                            />
                            <FormControlLabel
                              value="latest"
                              control={<Radio />}
                              label="Get Latest Meeting Id"
                            />
                          </RadioGroup>

                          {selectedMeetingMode[config.title] === "select" && (
                            <FormControl fullWidth size="small" style={{ marginTop: "10px" }}>
                              <InputLabel>Select Meeting</InputLabel>
                              <Select
                                value={configValues[config.title] || ""}
                                onChange={(e) =>
                                  handleConfigChange(config.title, e.target.value)
                                }
                                label="Select Meeting"
                                disabled={isMeetingDataLoading}
                                MenuProps={{
                                  anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                  getContentAnchorEl: null,
                                  PaperProps: {
                                    style: {
                                      maxHeight: 300,
                                    },
                                  },
                                }}
                                renderValue={(selected) => {
                                  const meeting = meetingData.find(
                                    (m) => m.meeting_id === selected
                                  );
                                  const displayName = meeting?.meeting_name || meeting?.meeting_id || "";
                                  return displayName.length > 30
                                    ? `${displayName.substring(0, 30)}...`
                                    : displayName;
                                }}
                              >
                                {isMeetingDataLoading ? (
                                  <MenuItem disabled>Loading...</MenuItem>
                                ) : meetingData.length > 0 ? (
                                  meetingData.map((meeting) => (
                                    <MenuItem
                                      key={meeting.meeting_id}
                                      value={meeting.meeting_id}
                                    >
                                      <Tooltip
                                        title={meeting.meeting_name || meeting.meeting_id}
                                        placement="top"
                                      >
                                        <span>
                                          {(meeting.meeting_name || meeting.meeting_id).length > 40
                                            ? `${(meeting.meeting_name || meeting.meeting_id).substring(0, 40)}...`
                                            : meeting.meeting_name || meeting.meeting_id}
                                        </span>
                                      </Tooltip>
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No meeting</MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          )}
                        </div>
                      )}
                  </div>
                  {(selectedAction.toolName === "Send Post Request" ||
                    selectedAction.toolName === "Send GET Request") &&
                    config.title === "API Header" ? (
                    <div>
                      {apiHeaderKeyPairs.map((pair, pairIndex) => (
                        <div
                          key={pairIndex}
                          style={{
                            display: "flex",
                            gap: "0.5rem",
                            marginBottom: "0.5rem",
                            alignItems: "center",
                          }}
                        >
                          <TextField
                            label="Key"
                            value={pair.key}
                            onChange={(e) =>
                              handleApiHeaderChange(
                                pairIndex,
                                "key",
                                e.target.value,
                              )
                            }
                            required={isApiHeaderRequired}
                          />
                          <TextField
                            label="Value"
                            value={pair.value}
                            onChange={(e) =>
                              handleApiHeaderChange(
                                pairIndex,
                                "value",
                                e.target.value,
                              )
                            }
                            required={isApiHeaderRequired}
                          />
                          {apiHeaderKeyPairs.length > 1 && (
                            <IconButton
                              aria-label="delete"
                              onClick={() => removeApiHeaderPair(pairIndex)}
                            >
                              <img src={XIcon} alt="Delete" />
                            </IconButton>
                          )}
                        </div>
                      ))}
                      <Button
                        variant="text"
                        onClick={addApiHeaderPair}
                        style={{ textTransform: "none" }}
                      >
                        + Add More
                      </Button>
                      {isApiHeaderRequired && configErrors["API Header"] && (
                        <p
                          style={{
                            color: "#d32f2f",
                            fontSize: "0.75rem",
                          }}
                        >
                          At least one key-value pair is required and all fields
                          must be filled.
                        </p>
                      )}
                    </div>
                  ) : config.type === "Text Field" ? (
                    selectedAction.toolName !== "Get Meeting Transcription" &&
                    selectedAction.toolName !== "Ontvang een vergadertranscriptie" && (
                      <TextField
                        fullWidth
                        placeholder={
                          configTypes[config.title] === "Use AI"
                            ? "Instructions to pick up from flow"
                            : config.hint
                        }
                        value={configValues[config.title] || ""}
                        onChange={(e) =>
                          handleConfigChange(config.title, e.target.value)
                        }
                        error={configErrors[config.title]}
                        helperText={
                          configErrors[config.title]
                            ? "This field is required"
                            : ""
                        }
                        disabled={configTypes[config.title] === "Dynamic"}
                      />
                    )
                  ) : config.type === "Text Area" &&
                    config.title !== "Name of Skill" ? (
                    selectedAction.toolName !== "Get Meeting Transcription" &&
                    selectedAction.toolName !== "Ontvang een vergadertranscriptie" && (
                      <TextareaAutosize
                        minRows={3}
                        placeholder={
                          configTypes[config.title] === "Use AI"
                            ? "Instructions to pick up from flow"
                            : config.hint + "hello"
                        }
                        value={configValues[config.title] || ""}
                        onChange={(e) =>
                          handleConfigChange(config.title, e.target.value)
                        }
                        disabled={configTypes[config.title] === "Dynamic"}
                        style={{
                          width: "-webkit-fill-available",
                          padding: "11px 16px",
                          borderRadius: "1rem",
                          border: configErrors[config.title]
                            ? "1px solid #d32f2f"
                            : "1px solid rgba(0, 0, 0, 0.23)",
                          fontFamily: "inherit",
                        }}
                      />
                    )
                  ) : (
                    config.type === "Dropdown" && (
                      <Box sx={{ minWidth: 120 }}>
                        <FormControl fullWidth>
                          <InputLabel id={`select-label-${config.title}`}>
                            {config.title}
                          </InputLabel>
                          <Select
                            labelId={`select-label-${config.title}`}
                            id={`select-${config.title}`}
                            value={selectedOptions[config.title] || ""}
                            label={config.title}
                            onChange={(e) =>
                              handleOptionChange(config.title, e.target.value)
                            }
                            error={configErrors[config.title]}
                          >
                            {config.options.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    )
                  )}
                  {!(
                    (selectedAction.toolName === "Send Post Request" ||
                      selectedAction.toolName === "Send GET Request") &&
                    config.title === "API Header"
                  ) &&
                    configErrors[config.title] &&
                    config.type === "Dropdown" && (
                      <p
                        style={{
                          color: "#d32f2f",
                          fontSize: "0.75rem",
                        }}
                      >
                        This field is required
                      </p>
                    )}
                  <p
                    style={{
                      fontSize: "14px",
                      marginTop: "unset",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <img src={InfoIcon} alt="Info" />
                    {config.description}
                  </p>
                </div>
              ))}
            </>
          )}
      </ToolConfigurationBody>
      <ToolConfigurationFooter>
        <ToolConfigurationCancelButton variant="outlined" onClick={onClose}>
          Cancel
        </ToolConfigurationCancelButton>
        <ToolConfigurationSaveButton variant="contained" onClick={handleSave}>
          Save
        </ToolConfigurationSaveButton>
      </ToolConfigurationFooter>
    </ToolBarContainer>
  );
};

export default ToolConfiguration;
